<template>
  <div class="grade-select" v-if='lessonId'>
    <banner-cp :banner='cp_banner' v-if='cp_banner'></banner-cp>
    <div class="mainer">
      <div
        class="block"   
        v-for="(itm, idx) in list"
        :key="idx"
      >
        <div class="bTitle">
          请选择
          <span class="color-orange">{{itm.periodName}}</span>
        </div>
        <ul class="sItem sItem2">
          <li
            v-for="(item,index) in itm.grandList"
            :key="index"
            @click="setGradeInfo(item,itm)"
            :class="{hover: gradeSelectResult.gradeId === item.gradeId && periodId === itm.periodId}"
          >{{item.gradeName}}</li>
        </ul>
      </div>
      <div class="sButton" v-if="list.length">
        <button
          class="btn"
          @click="goChooseEdition"
        >确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
import { cd_baseUrl } from '@/assets/js/api'
import bannerCp from '@/components/common/Banner'
export default {
    name: 'GradeSelect',
    components:{
        bannerCp
    },
    data () {
        return {
            list: [],
            gradeSelectResult: {},
            periodId: '',
            lessonId: '',
            wxUrls: [], 
            phone:'',
            banner:''
        }
    },
    created () {
        this.lessonId = this.$route.query.lessonId;
        sessionStorage.setItem('lessonId',this.lessonId)
        sessionStorage.setItem('lessonId',this.lessonId)
        // sessionStorage.setItem('wxShareUrl',window.shareUrl)

      if(!sessionStorage.getItem('firstrPageNotLoadFirst')) {
        sessionStorage.setItem('firstrPageNotLoadFirst',true);
        window.location.reload();
      }
      this.getMicroClassCustom(this.lessonId);
    },
    mounted () {
    },
    computed: {
        cp_banner () {
            return this.banner
        }
    },
    methods: {
        getMicroClassCustom (lessonId) {
            var that = this;
            this.$axios.get(cd_baseUrl + '/microClassCustom/customMade/info', {
                params: {
                    id: lessonId,
                }
            }).then(res => {
                if (res && res.data.errcode === 0) {
                    let { wxUrls, phone, bannerOld, name } = res.data.data;
                    document.title = '优学派同步课程' + (res.data.data.name || '');
                    sessionStorage.setItem('titleName',res.data.data.name);
                    sessionStorage.setItem('phone', phone)//用于后续视频播放内容及单元目标数据等
                    sessionStorage.setItem('wxUrls', JSON.stringify(wxUrls))
                    sessionStorage.setItem('banner', bannerOld)
                    sessionStorage.setItem('wxShareName', name);
                    if(!sessionStorage.getItem('goback') && localStorage.getItem(lessonId)) {
                        let param = localStorage.getItem(lessonId);
                        if(param) {
                            try {
                                param = JSON.parse(param);
                                this.$router.push({
                                    name: 'Home',
                                    query: { params: paramsHelper.encode(param), lessonId: lessonId, }
                                })
                            } catch (e) {
                                Object.assign(that, {
                                    banner:bannerOld,
                                    phone,
                                    wxUrls,
                                });
                                localStorage.removeItem(lessonId);
                                this.getGradeList(this.lessonId);
                            }
                        }
                    } else {
                        sessionStorage.removeItem('goback');
                        Object.assign(that, {
                            banner:bannerOld,
                            phone,
                            wxUrls,
                        });
                        this.getGradeList(this.lessonId);
                    }
                }else{
                    if(res.data.errcode == 1200){
                        that.$router.push({
                            name: 'ErrorPage',
                            query: { errmsg: res.data.errmsg }
                        })
                    }else{
                        that.$toast(res.data.errmsg);
                    }
                }

            }).catch(function (err) {
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
        getGradeList (lessonId) {
            var that = this;
            this.$axios.get(cd_baseUrl + '/microClassCustom/link/gradeList', {
                params: {
                    lessonId
                }
            }).then(res => {
                if (res && res.data.errcode === 0) {
                    that.list = res.data.data.list;
                }else{
                    that.$toast(res.data.errmsg);
                }

            }).catch(function (err) {
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
        setGradeInfo (item, { periodId }) {
            this.gradeSelectResult = item;
            this.periodId = periodId
        },
        goChooseEdition () {
            if (!this.gradeSelectResult.gradeId) {
                this.$toast('请选择年级');
                return;
            }
            let eduSystemId = this.list[0].eduSystemId
            this.$router.push({
                name: 'EditionSelect',
                // query: { params: paramsHelper.encode({ gradeSelectResult: this.gradeSelectResult, eduSystemId, periodId: 1, lessonId: this.lessonId }) }
                query: { params: paramsHelper.encode({ gradeSelectResult: this.gradeSelectResult, eduSystemId, periodId: this.periodId, lessonId: this.lessonId }),lessonId: this.lessonId, }
            })
        },
    }
}
</script>

<style scope lang="less">
.grade-select {
}
</style>
